import { Button } from "../components/Button";

export function PrivacyPolicy({ onBack }) {
  return (
    <section className="client privacyPolicy">
      <header className="sectionHeader">
        <h2>📄 Политика конфиденциальности</h2>
        <p className="muted">Шаблон для stihiya.net / Mini App</p>
      </header>

      <div className="eventsToolbar">
        <Button onClick={onBack}>Назад</Button>
      </div>

      <article className="homeSurface privacyPolicy__body">
        <h3 className="privacyPolicy__h">1. Общие положения</h3>
        <p>
          Настоящая политика конфиденциальности определяет порядок обработки и защиты персональных данных
          пользователей приложения Stihiya Mini App (далее — «Приложение»).
        </p>
        <p>Используя Приложение, пользователь соглашается с условиями настоящей политики.</p>

        <h3 className="privacyPolicy__h">2. Какие данные мы собираем</h3>
        <p>Приложение может обрабатывать следующие данные:</p>
        <ul className="privacyPolicy__list">
          <li>Telegram ID пользователя</li>
          <li>имя и username (если передаются Telegram)</li>
          <li>данные, введённые пользователем в интерфейсе</li>
          <li>технические данные (IP, время запросов)</li>
        </ul>
        <p className="privacyPolicy__note">Мы не собираем избыточные данные.</p>

        <h3 className="privacyPolicy__h">3. Цели обработки данных</h3>
        <p>Данные используются для:</p>
        <ul className="privacyPolicy__list">
          <li>работы приложения</li>
          <li>авторизации пользователя</li>
          <li>сохранения прогресса</li>
          <li>улучшения сервиса</li>
        </ul>

        <h3 className="privacyPolicy__h">4. Правовое основание</h3>
        <p>Обработка персональных данных осуществляется:</p>
        <ul className="privacyPolicy__list">
          <li>на основании согласия пользователя</li>
          <li>в целях исполнения функционала приложения</li>
        </ul>

        <h3 className="privacyPolicy__h">5. Хранение данных</h3>
        <ul className="privacyPolicy__list">
          <li>данные хранятся на сервере приложения</li>
          <li>срок хранения — пока пользователь использует сервис</li>
          <li>по запросу данные могут быть удалены</li>
        </ul>

        <h3 className="privacyPolicy__h">6. Передача третьим лицам</h3>
        <p>Мы не передаём персональные данные третьим лицам, за исключением:</p>
        <ul className="privacyPolicy__list">
          <li>требований законодательства</li>
          <li>технических сервисов (хостинг и инфраструктура)</li>
        </ul>

        <h3 className="privacyPolicy__h">7. Защита данных</h3>
        <p>Мы принимаем разумные меры для защиты данных:</p>
        <ul className="privacyPolicy__list">
          <li>ограничение доступа</li>
          <li>использование HTTPS</li>
          <li>контроль доступа к серверу</li>
        </ul>

        <h3 className="privacyPolicy__h">8. Права пользователя</h3>
        <p>Пользователь имеет право:</p>
        <ul className="privacyPolicy__list">
          <li>узнать, какие данные хранятся</li>
          <li>запросить удаление данных</li>
          <li>отозвать согласие</li>
        </ul>

        <h3 className="privacyPolicy__h">9. Контакты</h3>
        <p>По вопросам обработки данных можно связаться:</p>
        <p>
          <a className="textLinkButton textLinkButton--anchor" href="mailto:isayeu@gmail.com">
            isayeu@gmail.com
          </a>
        </p>
      </article>
    </section>
  );
}
